/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NextService } from './nextService';
import { LastServiceDate } from './lastServiceDate';


export interface DairyServiceDatesResponseDTO { 
    next_service?: NextService;
    last_service?: LastServiceDate;
}

